// Notification reducer

import * as types from '../actions/actionTypes';

const INITIAL_STATE = {
    isOpen: false,
    severity: null,
    message: null,
};

export default function notificationReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.NOTIFICATION_OPEN: {
            return {
                isOpen: true,
                severity: action.severity || null,
                message: action.message || null,
            };
        }

        case types.NOTIFICATION_CLOSE: {
            return {
                ...state,
                isOpen: false,
            };
        }

        default:
            return state;
    }
}
